module.exports = __webpack_public_path__ + "img/logo_regtime.84970d6c.svg";